export const RelatedSectionType = {
	Documents: "documents",
	Contracts: "contracts",
	Properties: "properties",
	Services: "services",
} as const;

import {
	type ClientPortfolioDetailRelatedResponseDTO,
	type ClientPortfolioDetailToolResponseDTO,
	ClientPortfolioDomainEnum,
	type PortfolioDocumentListItemDTO,
} from "web_myplann/Infrastructure/Api/Api";

const isServiceOrAdvisoryDomain = (
	domain: ClientPortfolioDomainEnum | undefined,
) => {
	return (
		domain === ClientPortfolioDomainEnum.Services ||
		domain === ClientPortfolioDomainEnum.PaidAdvisory
	);
};

export function computeRelatedPresence(
	documents: PortfolioDocumentListItemDTO[] | undefined,
	related: ClientPortfolioDetailRelatedResponseDTO[] = [],
	tools?: ClientPortfolioDetailToolResponseDTO[],
) {
	const hasDocuments = !!documents && documents.length > 0;
	const hasRelatedContracts = related.some(
		(r) =>
			r.relatedPortfolio &&
			!isServiceOrAdvisoryDomain(r.relatedPortfolio.domain),
	);
	const hasRelatedProperties = related.some((r) => r.relatedProperty);
	const hasRelatedServices = related.some(
		(r) =>
			r.relatedPortfolio?.domain &&
			isServiceOrAdvisoryDomain(r.relatedPortfolio.domain),
	);
	const hasTools = Array.isArray(tools) && tools.length > 0;

	return {
		hasDocuments,
		hasRelatedContracts,
		hasRelatedProperties,
		hasRelatedServices,
		hasTools,
		hasAny:
			hasDocuments ||
			hasRelatedContracts ||
			hasRelatedProperties ||
			hasRelatedServices ||
			hasTools,
	};
}
